

<div class="login-content full-height">
  <div nz-row nzJustify="space-around" nzAlign="middle" >
    <div class="container-logo"><img src="../../../../assets/images/logo.png" class="center img-login-logo responsive" /></div>
    <div class="login-box" nz-col [nzXs]="{ span: 20, offset: 2 }" [nzSm]="{ span: 14, offset: 5 }" [nzMd]="{ span: 10, offset: 7 }" [nzLg]="{ span: 8, offset: 8 }" [nzXl]="{ span: 8, offset: 8 }" [nzXXl]="{ span: 6, offset: 9 }">
      <div class="kt-login__title" id="login_form_title">
        <h2 class="text-center">TFI App</h2>
        <h4 class="text-center text-red">Bina Nusantara University</h4><br/>
      </div>
      <div class="main-overlay" *ngIf="isProcess">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      </div>
      <form  nz-form class="login-form" (ngSubmit)="submitAzureForm()" >
        <!-- <nz-form-item>
          <nz-form-control nzErrorTip="Please input your username!">
            <nz-input-group nzPrefixIcon="user">
              <input type="text" nz-input formControlName="email" placeholder="Username" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control nzErrorTip="Please input your Password!">
            <nz-input-group nzPrefixIcon="lock">
              <input type="password" nz-input formControlName="password" placeholder="Password" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <div nz-row class="login-form-margin">
          <div nz-col [nzSpan]="12">
            <label nz-checkbox formControlName="remember">
              <span>Remember me</span>
            </label>
          </div>
        </div> -->
        <button nz-button class="login-form-button login-form-margin" [nzType]="'primary'">Log in</button>
      </form>
    </div>
  </div>
</div>
<nz-footer class="fixed-bottom">
  <div nz-row nzJustify="space-between" nzAlign="bottom">
    <p id="footer_login" class="text-center">Copy Right © 2020. Bina Nusantara University - All Rights Reserved</p>
  </div>
</nz-footer>

